// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type BidProjectFieldsQueryVariables = Types.Exact<{
  projectFilter?: Types.InputMaybe<Types.ProjectFilter>;
}>;


export type BidProjectFieldsQuery = { __typename?: 'Query', projects: Array<
    | { __typename?: 'StandaloneProject', id: string, name: string }
    | { __typename?: 'Region', id: string, name: string }
    | { __typename?: 'Market', id: string, name: string }
    | { __typename?: 'Community', id: string, name: string }
    | { __typename?: 'Subdivision', id: string, name: string }
    | { __typename?: 'Lot', id: string, name: string }
    | { __typename?: 'Structure', id: string, name: string }
    | { __typename?: 'Unit', id: string, name: string }
  > };


export const BidProjectFieldsDocument = gql`
    query BidProjectFields($projectFilter: ProjectFilter) {
  projects(filter: $projectFilter) {
    ...Named
  }
}
    ${NamedFragmentDoc}`;

/**
 * __useBidProjectFieldsQuery__
 *
 * To run a query within a React component, call `useBidProjectFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBidProjectFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBidProjectFieldsQuery({
 *   variables: {
 *      projectFilter: // value for 'projectFilter'
 *   },
 * });
 */
export function useBidProjectFieldsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BidProjectFieldsQuery, BidProjectFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BidProjectFieldsQuery, BidProjectFieldsQueryVariables>(BidProjectFieldsDocument, options);
      }
export function useBidProjectFieldsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BidProjectFieldsQuery, BidProjectFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BidProjectFieldsQuery, BidProjectFieldsQueryVariables>(BidProjectFieldsDocument, options);
        }
// @ts-ignore
export function useBidProjectFieldsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BidProjectFieldsQuery, BidProjectFieldsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BidProjectFieldsQuery, BidProjectFieldsQueryVariables>;
export function useBidProjectFieldsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidProjectFieldsQuery, BidProjectFieldsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BidProjectFieldsQuery | undefined, BidProjectFieldsQueryVariables>;
export function useBidProjectFieldsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidProjectFieldsQuery, BidProjectFieldsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BidProjectFieldsQuery, BidProjectFieldsQueryVariables>(BidProjectFieldsDocument, options);
        }
export type BidProjectFieldsQueryHookResult = ReturnType<typeof useBidProjectFieldsQuery>;
export type BidProjectFieldsLazyQueryHookResult = ReturnType<typeof useBidProjectFieldsLazyQuery>;
export type BidProjectFieldsSuspenseQueryHookResult = ReturnType<typeof useBidProjectFieldsSuspenseQuery>;
export type BidProjectFieldsQueryResult = ApolloReactCommon.QueryResult<BidProjectFieldsQuery, BidProjectFieldsQueryVariables>;